import axios from 'axios';

import {
    DefaultItemsResponse, MappedDefaultItemsResponse,
} from '@/types';

export const api = axios.create({
    withCredentials: true,
});

export const mapItemsResponse = <T>(data: DefaultItemsResponse<T>): MappedDefaultItemsResponse<T> => {
    return {
        items: data.data,
        total: data.meta.total,
        per_page: data.meta.per_page,
        current_page: data.meta.current_page,
    };
};
